import { Grid, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { observer } from 'mobx-react';
import { Paper } from '@roc/ui';
import { sanitizeHtml } from '@roc/ui/utils';
import { WarningOutlined, ErrorOutline } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  paper: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: '#FEF0ED',
    color: '#642B20',
    marginTop: '-18px',
  },
  paperV2: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: '#FEF0ED',
    color: '#642B20',
    marginTop: '16px'
  },
  content: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
  messageBox: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: '#FEF0ED',
    color: '#642B20',
    borderRadius: 16
  },
  blueMessageBox: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    color: `rgb(37, 62, 93)`,
    backgroundColor: `rgb(238, 245, 252)`,
    borderRadius: 16
  },
  icon: {
    color: theme.palette.warning.light,
  },
  iconBlue: {
    color: theme.palette.info.light,
  },
  titleContainer: {
    paddingBottom: '0px !important'
  },
  inlineItemTypography: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21.98px',
    letterSpacing: '0.1px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  }
}));




export const BannerMessages = observer((props) => {
  const classes = useStyles();
  const { messages, isInlineItem, isBlueBanner } = props;
  const { newDesignForSummaryScreen } = props;
  let messageComponents = [];
  messageComponents = messages && messages.map(message => {
    const content = message.content;
    return (
      <Grid container className={classes.content} spacing={2}>
        <Grid item>
          {newDesignForSummaryScreen ? <ErrorOutline className={isBlueBanner ? classes.iconBlue : classes.icon} /> : <WarningOutlined className={isBlueBanner ? classes.iconBlue : classes.icon} />}
        </Grid>
        <Grid item xs={11} className={classes.titleContainer}>
          <Typography className={isInlineItem ? classes.inlineItemTypography : ''}>
            <strong>
              {message.title}
            </strong>
            <br />
            {typeof content === 'string' ? (
              <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} />
            ) : (
              content
            )}
          </Typography>
        </Grid>
      </Grid>
    );
  });
  return (
    <>
      {messages?.length > 0 ? (
        <>
          {!newDesignForSummaryScreen && <Paper className={isInlineItem ? classes.paperV2 : classes.paper} title="">
            {messageComponents}
          </Paper>}
          {newDesignForSummaryScreen && <Box className={isBlueBanner ? classes.blueMessageBox
            : classes.messageBox}>{messageComponents}</Box>}
          <br />
        </>) : <Grid />
      }
    </>
  );
});
